import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  DescriptionFormStyle: {
    '& textarea': {
      padding: '0!important'
    }
  },
  input: {
    // Hide the spinner buttons for Chrome, Safari, Edge, Opera
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      {
        WebkitAppearance: 'none',
        margin: 0
      },
    // Hide the spinner buttons for Firefox
    '& input[type=number]': {
      MozAppearance: 'textfield'
    },
    '& fieldset': {
      borderRadius: '0 .25rem .25rem 0'
    },
    width: '100%'
  },
  dFlex: {
    display: 'flex'
  },
  fixedLabel: {
    padding: '.5rem',
    backgroundColor: 'var(--mui-palette-transparent-a5)',
    border: `1px solid ${theme.vars.palette.border.light}`,
    borderRadius: '.25rem 0 0 .25rem'
  },
  fullWidth: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0 .25rem .25rem 0'
    }
  },
  activationFeild: {
    width: '100%',
    '& fieldset': {
      borderRadius: '.25rem 0 0 .25rem'
    }
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem',
    alignItems: 'center'
  },
  warningColor: {
    color: theme.vars.palette.warning.main
  }
}));

export default useStyles;
